import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import addModal from './addModal.vue';
import { columns, statusSelectList } from './utils';
import { claimsDocumentList, claimsDocumentUpdate, claimsDocumentDelete, claimsDocumentDetail } from './request';
export default {
  components: {
    addModal
  },
  data() {
    return {
      columns,
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      statusSelectList,
      form: {
        name: '',
        status: undefined
      },
      tableData: [],
      selectedRowKeys: []
    };
  },
  created() {
    this.searchFun();
  },
  methods: {
    searchFun() {
      this.pagination.current = this.pagination.page = 1;
      this.getListData();
    },
    async getListData() {
      const {
        items,
        totalNum
      } = await claimsDocumentList(Object.assign(this.form, {
        page: this.pagination.page,
        pageSize: this.pagination.pageSize
      }));
      this.tableData = items;
      this.pagination.total = totalNum;
      let lastPage = Math.ceil(this.pagination.total / this.pagination.pageSize);
      if (this.pagination.page === lastPage + 1 && this.pagination.total % (this.pagination.pageSize * (this.pagination.page - 1)) === 0) {
        this.pagination.page -= 1;
        this.pagination.current -= 1;
        this.getListData();
      }
    },
    onAdd() {
      this.$refs.addRef.openModal('add', false, true);
    },
    async onEdit(id) {
      const res = await claimsDocumentDetail({
        claimsDocumentId: id
      });
      this.$refs.addRef.openModal('edit', res, false);
    },
    async onDelete({
      status,
      claimsDocumentId: id
    }) {
      console.log(id);
      let res;
      if (Array.isArray(id)) {
        res = this.filterCheckedStatus(id, this.tableData, 'claimsDocumentId');
      }
      if (status === 1 || res) {
        this.$message.warn(this.$t('请先禁用类型再删除'));
        return;
      }
      await this.$alert(this.$t('是否确认删除?'), {
        confirmButtonText: this.$t('确定')
      });
      await claimsDocumentDelete({
        claimsDocumentId: Array.isArray(id) ? id : [id]
      });
      this.$message.success(this.$t('删除成功'));
      this.getListData();
    },
    async batchDelete() {
      if (this.selectedRowKeys.length) {
        await this.onDelete({
          status: null,
          claimsDocumentId: this.selectedRowKeys
        });
        this.selectedRowKeys = [];
      } else {
        this.$message.error(this.$t('请选择要删除的数据'));
      }
    },
    // 批量删除时过滤选中状态
    filterCheckedStatus(ids, list, id) {
      let isOK = false;
      list.map(item => {
        if (ids.indexOf(item[id]) > -1 && item.status === 1) {
          isOK = true;
        }
      });
      return isOK;
    },
    tablePageChange(val) {
      this.pagination = val;
      this.pagination.page = val.current;
      this.getListData();
    },
    onSelectChange(val) {
      this.selectedRowKeys = val;
    },
    async checkedStatus(checked, id) {
      await claimsDocumentUpdate({
        claimsDocumentId: id,
        status: checked ? 1 : 0
      });
      this.$message.success(this.$t('保存成功'));
      this.getListData();
    },
    isChecked(text) {
      return text;
    }
  }
};